// extracted by mini-css-extract-plugin
export default {"tag":"StatusTag_tag__7Rpee","ok":"StatusTag_ok__hlmo7","info":"StatusTag_info__ONBOt","idle":"StatusTag_idle__PuUN0","err":"StatusTag_err__Tc19J"};